<script lang="ts">
  import type { HTMLInputAttributes } from "svelte/elements";
  import { cn } from "$lib/utils/cn";
  import { fieldStateClass, fieldStateFocusRing, type FormFieldState } from "./fieldState";

  type Props = Omit<HTMLInputAttributes, "value"> & {
    class?: string;
    invalid?: boolean;
    /** @deprecated Prefer `state="filled"`. */
    autofilled?: boolean;
    state?: FormFieldState;
    value?: HTMLInputAttributes["value"];
  };

  let {
    class: className,
    invalid = false,
    autofilled = false,
    state,
    type = "text",
    value = $bindable(),
    ...rest
  }: Props = $props();

  const visualState = $derived(state ?? (invalid ? "invalid" : autofilled ? "filled" : "default"));
</script>

<input
  {type}
  bind:value
  class={cn(
    "surface-input",
    "h-10 w-full rounded-md px-3 text-sm",
    "placeholder:text-(--surface-fg-subtle)",
    "transition-[border-color,box-shadow,background-color] duration-fast ease-standard",
    "focus:outline-none focus:ring-2",
    fieldStateFocusRing(visualState, invalid),
    fieldStateClass(visualState, { invalid, autofilled }),
    "disabled:opacity-60 disabled:cursor-not-allowed",
    className,
  )}
  aria-invalid={visualState === "invalid" || invalid || undefined}
  {...rest}
/>
